import Wfs3dProperties from "../dto/Wfs3dProperties";

export const extractWfs3dProperties = (entity: any) => {
    const upperLimit = entity._properties.upperLimit || 0;
    const lowerLimit = entity._properties.lowerLimit || 0;
    const leftWidth = entity._properties.leftWidth || 0;
    const rightWidth = entity._properties.rightWidth || 0;
    return new Wfs3dProperties(lowerLimit, upperLimit, leftWidth, rightWidth);
};

export const extractWfs3dPropertiesWithHeightMultiplier = (entity: any, heightMultiplier: number) => {
    const upperLimit = entity._properties.upperLimit * heightMultiplier || 0;
    const lowerLimit = entity._properties.lowerLimit * heightMultiplier || 0;
    const leftWidth = entity._properties.leftWidth || 0;
    const rightWidth = entity._properties.rightWidth || 0;
    return new Wfs3dProperties(lowerLimit, upperLimit, leftWidth, rightWidth);
};
